const styles = (theme) => ({
  container: {
    width: "100%",
  },
  form: {
    marginBottom: "20px",
  },
  label: {
    fontWeight: "bold",
    marginBottom: "10px",
    color: theme.palette.primary.mainColor + "!important",
  },
  labelError: {
    fontWeight: "bold",
    marginBottom: "10px",
    color: "red",
  },
  selectInput: {
    width: "100%",
  },
  customCheckbox: {
    color: theme.palette.primary.main,
    "&:checked": {
      color: theme.palette.primary.main,
    },
  },
  customRadio: {
    color: theme.palette.primary.main,
    "&$checked": {
      color: theme.palette.primary.main,
    },
  },
  checked: {},
  chip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    margin: "auto 5px",
  },
  totalPoints: {
    fontWeight: "bold",
    fontSize: "2rem",
  },
  buttonContainer: {
    margin: "20px auto",
  },
});

export default styles;
